import React from "react";
import {useInternalDataContext, useMaterialModalContext} from "../../MaterialModalProvider";
import Modal from "../../../../../../../../../components/modal/Modal";
import {MaterialModalTabs} from "../../components/MaterialModalTabs";
import {MaterialType} from "../../../../../models/enums";
import {PrebuildTabContent} from "./components/PrebuildTabContent";
import {CatalogTabContent} from "./components/CatalogTabContent";
import {OneOffMaterialChangeModal} from "./components/one-off/OneOffMaterialChangeModal";
import {TemplateTabContent} from "./components/template/TemplateTabContent";

const MaterialChangeModal: React.FC = function() {
	const {closeModal} = useMaterialModalContext()
	const {modalTab} = useInternalDataContext()

	return (
		<>
			{modalTab.active === MaterialType.ONE_OFF ? (
				<OneOffMaterialChangeModal/>
			) : (
				<Modal isOpen={true} onClose={closeModal} customClass="material-modal">
					<div className="material-modal_container">
						<MaterialModalTabs/>
						{modalTab.active === MaterialType.TEMPLATE ? <TemplateTabContent/> : null}
						{modalTab.active === MaterialType.PREBUILD ? <PrebuildTabContent/> : null}
						{modalTab.active === MaterialType.CATALOG ? <CatalogTabContent/> : null}
					</div>
				</Modal>
			)}
		</>
	)
}

export {MaterialChangeModal}